import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { api } from '../../api';
import { sentryLogError } from '../../utils';

import type { TCreateThunkApi } from './models';
import { draftCheckRequest } from './draft-check';
import { setDraftCookie } from './draft';
import {
    setStep,
    setStatus,
    setErrorStep,
    setUserStatus,
    setLastDtPathStatus,
} from './application';
import { setCashbackApplyStatus } from './first-step';

/** Запрос на проверку паспорта */
export const passportCheckRequest = createAsyncThunk<void, string, TCreateThunkApi>(
    'passportCheckRequest',
    async (passportFullNumber, { dispatch, getState }) => {
        const {
            application: { appId, businessUid, gentleErrorEnabled },
        } = getState();

        try {
            const { data } = await api.passportCheck({ passportFullNumber, appId, businessUid });
            const { lastDtPathStatus, status } = data;

            dispatch(setLastDtPathStatus(lastDtPathStatus));

            if (status === 'APPROVAL_REJECT') {
                dispatch(setStep('smsConfirm'));

                return;
            }

            if (status === 'NODT' || status === 'SUCCESS') {
                dispatch(setStep(gentleErrorEnabled ? 'gentleErrorPage' : 'delivery'));
                dispatch(setStatus(status));
                if (data.cashbackStatus) {
                    dispatch(setCashbackApplyStatus(data.cashbackStatus));
                }
                if (data?.payload?.userStatus) {
                    dispatch(setUserStatus(data.payload.userStatus));
                }

                await dispatch(draftCheckRequest());
                dispatch(setDraftCookie(data.draftId));

                return;
            }

            sentryLogError({
                message: 'applicationsPassportCheck error',
                data: { appId, businessUid, status },
            });

            dispatch(setErrorStep(status));
        } catch (error) {
            sentryLogError({
                error,
                message: 'applicationsPassportCheck error',
                data: { appId, businessUid },
            });

            if (!axios.isAxiosError(error)) {
                dispatch(setErrorStep());

                return;
            }

            dispatch(setErrorStep(error?.response?.data?.status));
        }
    }
);
